module.exports = __webpack_public_path__ + "805b7a5f33449f85a0ca6c164426de02.ttf";